// @ts-nocheck
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import filterViewerFromAttendees from 'helpers/filterViewerFromAttendees'

import HideVisually from 'js/components/HideVisually/HideVisually'
import People from 'js/components/People'

import type { EventItemQuery } from '../EventPage/EventItem.queries.generated'
import type { EventItemViewFragment } from '../EventPage/EventItemView.fragment.generated'

import { AttendeesModal } from './components/AttendeesModal'
import styles from './EventAttendees.module.css'

type Props = {
    entity: EventItemViewFragment
    viewer: EventItemQuery['viewer']
}

const EventAttendeesButton = ({
    total,
    label,
    onClick,
}: {
    total: NonNullable<EventItemViewFragment['attendees']>['totalAccept']
    label: string
    onClick: any
}) => {
    const { t } = useTranslation()

    return (
        <button
            className={styles.attendeesColumn}
            type="button"
            onClick={onClick}
        >
            <div className={styles.attendeesNumber} aria-hidden>
                {total}
            </div>
            <div className={styles.attendeesStatus} aria-hidden>
                {label}
            </div>
            <HideVisually>
                {t('entity-event.view-attendees')} ({total} {label})
            </HideVisually>
        </button>
    )
}

export const EventAttendees = ({ entity, viewer }: Props) => {
    const {
        attendees,
        isAttending,
        rsvp,
        attendEventWithoutAccount,
        enableMaybeAttendEvent,
        attendEventOnline,
    } = entity
    const { totalAccept, totalMaybe, totalOnline, totalReject } = attendees
    const { loggedIn } = viewer

    const { t } = useTranslation()

    const [attendeesModal, setAttendeesModal] = useState(false)

    if (!loggedIn || (loggedIn && !rsvp && !attendEventWithoutAccount)) {
        return null
    }

    return (
        <div>
            <button
                type="button"
                className={styles.attendeesPeople}
                onClick={() => setAttendeesModal('going')}
            >
                <People
                    showCheck={isAttending === 'accept'}
                    checkLabel={t('entity-event.you-are-going')}
                    users={
                        isAttending === 'accept'
                            ? filterViewerFromAttendees(
                                  attendees.edges,
                                  viewer.user.guid,
                              )
                            : attendees.edges
                    }
                    total={totalAccept}
                    size="large"
                    disableProfileCard
                    aria-hidden
                />
                <HideVisually>
                    {t('entity-event.view-attendees')} ({totalAccept}{' '}
                    {t('entity-event.going')})
                </HideVisually>
            </button>

            <div className={styles.attendeesColumns}>
                <EventAttendeesButton
                    total={totalAccept}
                    label={t('entity-event.going')}
                    onClick={() => setAttendeesModal('going')}
                />

                {attendEventOnline && (
                    <EventAttendeesButton
                        total={totalOnline}
                        label={t('entity-event.online')}
                        onClick={() => setAttendeesModal('online')}
                    />
                )}

                {enableMaybeAttendEvent && (
                    <EventAttendeesButton
                        total={totalMaybe}
                        label={t('entity-event.maybe')}
                        onClick={() => setAttendeesModal('maybe')}
                    />
                )}

                <EventAttendeesButton
                    total={totalReject}
                    label={t('entity-event.not-going')}
                    onClick={() => setAttendeesModal('not-going')}
                />
            </div>

            <AttendeesModal
                tab={attendeesModal}
                setTab={setAttendeesModal}
                entity={entity}
            />
        </div>
    )
}
